import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/table-actions-mobile.css';
import './styles/foundation.css';
import App from './App';
import StagingBanner from './components/StagingBanner';
import SupportContextBanner from './components/SupportContextBanner';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { BrowserRouter } from 'react-router-dom';
import { installContextInterceptor } from './api/contextInterceptor';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { svSE, enUS } from '@mui/material/locale';
import { getLang } from './i18n';

// MUI's own texts (table pagination etc.) follow the chosen language. The base theme is MUI's default.
const muiTheme = createTheme({}, getLang() === 'sv' ? svSE : enUS);

installContextInterceptor(store);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <React.StrictMode>
        <ThemeProvider theme={muiTheme}>
          <StagingBanner />
          <SupportContextBanner />
          <App />
        </ThemeProvider>
      </React.StrictMode>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
